import { IsNotEmpty, IsNumber, IsNumberString, IsString, Length } from "class-validator";

export class CreateBankDetailsDto {
  @IsString()
  @IsNotEmpty()
  bankName: string = '';

  @IsNumberString({ no_symbols: true })
  @Length(9)
  bik: string = '';

  @IsNumberString({ no_symbols: true })
  @Length(20)
  accountNumber: string = '';

  @IsNumberString({ no_symbols: true })
  @Length(20)
  corrAccountNumber: string = '';

  @IsNumber()
  legalEntityId: number = NaN;
}

export class BankDetailsDto extends CreateBankDetailsDto {
  id: number = NaN;

  /**
   * Разрешено ли выставлять исходящие (клиентские) счета/договоры с этими реквизитами.
   * Вычисляется по связанным расчётным счетам (см. BankAccount.allowOutgoingInvoices).
   * undefined — сервер не считал этот признак для данного запроса.
   */
  outgoingInvoicesAllowed?: boolean;
}

export class UpdateBankDetailsDto extends CreateBankDetailsDto {
  id: number;
}
